import React from 'react'
import PropTypes from 'prop-types'

import { useTheme } from 'styled-components'
import themeGet from '@styled-system/theme-get'

import HeadingTitle from 'Components/Blocks/_Legacy/Heading/HeadingTitle'
import Tag from 'Components/Blocks/_Legacy/Heading/Tag'
import { Column, Motion, Wrapper } from 'Components/UI'
import { Border, Text } from 'Components/UI/_Legacy'

import { iconUserGlyph } from 'Assets/_Legacy/CtoPage'

import { Container, Content } from './styles'

function WhoIs({ data }) {
  const theme = useTheme()

  return (
    <>
      <Border bg={themeGet('colors.bg.tertiary')({ theme })} primary topRight />

      <Container>
        <Wrapper>
          <Content>
            <Motion>
              <Column noShrink width={[1, 1, 400]}>
                <Tag
                  glyph={iconUserGlyph}
                  horizontalAlign="left"
                  light
                  text={data?.whoIsTagText}
                />
                <HeadingTitle
                  fontSize={[24, 24, 45]}
                  horizontalAlign="left"
                  light
                  titleText={{
                    first: { text: data?.whoIsTitleRegular, bold: false },
                    second: { text: data?.whoIsTitleBold, bold: true },
                  }}
                />
              </Column>
            </Motion>

            <Motion>
              <Text
                fontSize={[14, 14, 16]}
                fontWeight={350}
                mt={[16, 16, 24, 0]}
                white
              >
                {data?.whoIsDescription}
              </Text>
            </Motion>
          </Content>
        </Wrapper>
      </Container>

      <Border bottomLeft primary />
    </>
  )
}

WhoIs.defaultProps = {
  data: {},
}

WhoIs.propTypes = {
  data: PropTypes.object,
}

export default WhoIs
